import { useDispatch, useSelector } from "react-redux";
import { useState } from "react";
import cms from "../../../constants/cmskeys";
import cmsParser from "../../Services/CMSParser";
import {
  changePostalMailSection,
  changeCompanyName,
  changeCountryCode,
  changeSelectedState,
  changeCountryName,
  changeStreetAddress,
  changeAddLine2,
  changeAddLine3,
  changeAddLine4,
  changeAddLine5,
  changeCity,
  changeZipCode,
} from "../../../redux/Slices/PostMailSlice";
import { usStates } from "../../../constants/usstates";

const PostalMail = ({ cmsLabels }) => {
  const {
    isPostChecked,
    selectedState,
    countryCode,
    streetAddress,
    addLine2,
    addLine3,
    addLine4,
    addLine5,
    city,
    zipCode,
    companyName,
  } = useSelector((state) => state.postMail);

  const [addCount, setAddCount] = useState(0);

  const dispatch = useDispatch();

  const formatCountries = (listOfCountries) => {
    let formattedCountries = listOfCountries
      .replace(/<br\s*[/]?>/gi, "")
      .replace(/&amp;/g, "&");

    let __countries = JSON.parse(formattedCountries).sort((a, b) =>
      a.Value > b.Value ? 1 : b.Value > a.Value ? -1 : 0
    );
    return __countries;
  };
  const formatAddressLine = (line_number) => {
    return cmsParser(cms.Address_Line2, cmsLabels).replace("{0}", line_number);
  };
  const countries = formatCountries(cmsParser(cms.countries, cmsLabels));

  const countryOnChange = (e) => {
    dispatch(changeCountryCode(e.target.value));
    dispatch(changeSelectedState(""));
    dispatch(changeCountryName(e.target.selectedOptions[0].innerText));
  };

  const stateOnChange = (e) => {
    dispatch(changeSelectedState(e.target.value));
  };

  return (
    <div className="dds__py-2 dds__border-top">
      <div className="dds__checkbox">
        <label className="dds__checkbox__label dds__w-100" htmlFor="lrPostalCheck">
          <input
            className="dds__checkbox__input"
            type="checkbox"
            name="lrPostalCheck"
            id="lrPostalCheck"
            value="lg"
            onChange={() => dispatch(changePostalMailSection(!isPostChecked))}
          />
          <span tabIndex="-1">{cmsParser(cms.Postal_Mail, cmsLabels)}</span>
        </label>
      </div>
      <div
        className={
          "dds__py-4 dds__px-5 dds__d-none " +
          (isPostChecked ? "dds__d-block" : "dds__d-none")
        }
      >
        <div className="dds__row">
          <div className="dds__col--lg-8 dds__col--xl-6">
            <div
              className="dds__select dds__row dds__align-items-center dds__py-2"
              data-dds="select"
            >
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblLRCountry"
                  htmlFor="ddlCountry"
                  className="required-field"
                >
                  {cmsParser(cms.Country, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__select__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <select
                    id="ddlCountry"
                    className="dds__select__field"
                    aria-describedby="lblLRCountry"
                    value={countryCode}
                    onChange={countryOnChange}
                  >
                    {countries.map((item, i) => (
                      <option key={"country-option-" + i} value={item.Code}>
                        {item.Value}
                      </option>
                    ))}
                  </select>
                  <svg
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                    focusable="false"
                    className="dds__select__chevron"
                  >
                    <path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path>
                  </svg>
                  <svg
                    viewBox="0 0 32 32"
                    aria-hidden="true"
                    focusable="false"
                    className="dds__select__feedback__icon"
                  >
                    <path d="M16 2.14l-16 27.72h32l-16-27.72zM16 6.14l12.48 21.6h-24.96l12.48-21.52zM14.96 24h2v2h-2zM14.96 12.1h2v10h-2z"></path>
                  </svg>
                </div>
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblCompanyName" htmlFor="txtLRCompanyName">
                  {cmsParser(cms.Company_Name, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRCompanyName"
                    id="txtLRCompanyName"
                    aria-labelledby="lblCompanyName"
                    onChange={(e) =>
                      dispatch(changeCompanyName(e.target.value))
                    }
                    value={companyName}
                  />
                </div>
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblStreetAddress"
                  htmlFor="txtLRStreet"
                  className="required-field"
                >
                  {cmsParser(cms.Street_Address, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    value={streetAddress}
                    className="dds__input-text"
                    maxLength="256"
                    onChange={(e) =>
                      dispatch(changeStreetAddress(e.target.value))
                    }
                    name="txtLRStreet"
                    id="txtLRStreet"
                    required={isPostChecked}
                    aria-labelledby="lblStreetAddress"
                  />
                  <div
                    id="streetaddress-input-feedback"
                    className="dds__invalid-feedback"
                  >
                    {cmsParser(cms.validation_street_addr, cmsLabels)}
                  </div>
                </div>
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblAddressLine2" htmlFor="txtLRAddress2">
                  {formatAddressLine(2)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRAddress2"
                    id="txtLRAddress2"
                    aria-labelledby="lblAddressLine2"
                    onChange={(e) => dispatch(changeAddLine2(e.target.value))}
                    value={addLine2}
                  />
                </div>
              </div>
            </div>

            <div
              className={
                "dds__input-text__container dds__row dds__align-items-center " +
                (addCount >= 1 ? "dds__py-2" : "dds__py-2 dds__d-none")
              }
            >
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblAddressLine3" htmlFor="txtLRAddress3">
                  {formatAddressLine(3)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRAddress3"
                    id="txtLRAddress3"
                    aria-labelledby="lblAddressLine3"
                    onChange={(e) => dispatch(changeAddLine3(e.target.value))}
                    value={addLine3}
                  />
                </div>
              </div>
            </div>

            <div
              className={
                "dds__input-text__container dds__row dds__align-items-center " +
                (addCount >= 2 ? "dds__py-2" : "dds__py-2 dds__d-none")
              }
            >
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblAddressLine4" htmlFor="txtLRAddress4">
                  {formatAddressLine(4)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRAddress4"
                    id="txtLRAddress4"
                    aria-labelledby="lblAddressLine4"
                    onChange={(e) => dispatch(changeAddLine4(e.target.value))}
                    value={addLine4}
                  />
                </div>
              </div>
            </div>

            <div
              className={
                "dds__input-text__container dds__row dds__align-items-center " +
                (addCount >= 3 ? "dds__py-2" : "dds__py-2 dds__d-none")
              }
            >
              <div className="dds__col--md-4 dds__text-md-right">
                <label id="lblAddressLine5" htmlFor="txtLRAddress5">
                  {formatAddressLine(5)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRAddress5"
                    id="txtLRAddress5"
                    aria-labelledby="lblAddressLine5"
                    onChange={(e) => dispatch(changeAddLine5(e.target.value))}
                    value={addLine5}
                  />
                </div>
              </div>
            </div>

            <div className={addCount < 3 ? "dds__row" : "dds__row dds__d-none"}>
              <div className="dds__col--md-8 dds__ml-auto dds__pl-lg-3">
                <button
                  type="button"
                  onClick={() => setAddCount(addCount + 1)}
                  className="dds__button dds__button--tertiary dds__button--sm dds__my-2"
                >
                  + {cmsParser(cms.Add_Address, cmsLabels)}
                </button>
              </div>
            </div>

            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblCity"
                  htmlFor="txtLRCity"
                  className="required-field"
                >
                  {cmsParser(cms.City, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="256"
                    name="txtLRCity"
                    id="txtLRCity"
                    required={isPostChecked}
                    aria-labelledby="lblCity"
                    onChange={(e) => {
                      dispatch(changeCity(e.target.value));
                    }}
                    value={city}
                  />
                </div>
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblState"
                  htmlFor="txtLRState"
                  className="required-field"
                >
                  {cmsParser(cms.State_Province_Region, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                {countryCode === "US" ? (
                  <div className="dds__select__wrapper dds__flex-grow-1 dds__pl-md-2">
                    <select
                      id="ddlLRStates"
                      name="ddlLRStates"
                      value={selectedState}
                      onChange={stateOnChange}
                      className="dds__select__field"
                      aria-describedby="lblState"
                      required={isPostChecked && countryCode === "US"}
                    >
                      <option value="">Select State</option>
                      {usStates.map((item, i) => (
                        <option key={"state-option-" + i} value={item.code}>
                          {item.name}
                        </option>
                      ))}
                    </select>
                    <svg
                      viewBox="0 0 32 32"
                      aria-hidden="true"
                      focusable="false"
                      className="dds__select__chevron"
                    >
                      <path d="M30.48 7.24l-14.48 14.48-14.48-14.48-1.52 1.52 16 16 16-16z"></path>
                    </svg>
                    <svg
                      viewBox="0 0 32 32"
                      aria-hidden="true"
                      focusable="false"
                      className="dds__select__feedback__icon"
                    >
                      <path d="M16 2.14l-16 27.72h32l-16-27.72zM16 6.14l12.48 21.6h-24.96l12.48-21.52zM14.96 24h2v2h-2zM14.96 12.1h2v10h-2z"></path>
                    </svg>
                  </div>
                ) : (
                  <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                    <input
                      type="text"
                      className="dds__input-text"
                      value={selectedState}
                      maxLength="256"
                      name="txtLRState"
                      id="txtLRState"
                      required={isPostChecked}
                      aria-labelledby="lblState"
                      onChange={stateOnChange}
                    />
                  </div>
                )}
              </div>
            </div>
            <div className="dds__input-text__container dds__row dds__align-items-center dds__py-2">
              <div className="dds__col--md-4 dds__text-md-right">
                <label
                  id="lblPostalCode"
                  htmlFor="txtLRZip"
                  className="required-field"
                >
                  {cmsParser(cms.Zip_Code, cmsLabels)}
                </label>
              </div>
              <div className="dds__col--md-8">
                <div className="dds__input-text__wrapper dds__flex-grow-1 dds__pl-md-2">
                  <input
                    type="text"
                    className="dds__input-text"
                    maxLength="16"
                    name="txtLRZip"
                    id="txtLRZip"
                    required={isPostChecked}
                    aria-labelledby="lblPostalCode"
                    onChange={(e) => dispatch(changeZipCode(e.target.value))}
                    value={zipCode}
                  />
                </div>
              </div>
            </div>

            <div
              className={addCount >= 1 ? "dds__row" : "dds__row dds__d-none"}
            >
              <div className="dds__col--md-8 dds__ml-auto dds__pl-lg-3">
                <button
                  type="button"
                  onClick={() => {
                    setAddCount(0);
                  }}
                  className="dds__button dds__button--tertiary dds__button--sm dds__my-2"
                >
                  {" "}
                  {cmsParser(cms.Cancel, cmsLabels)}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PostalMail;
